import { useState } from "react";
import ProductListing from "@/components/ProductListing";

const TABS = [
  { key: "", label: "All Marts" },
  { key: "home-mart", label: "Home Mart" },
  { key: "style-mart", label: "Style Mart" },
  { key: "wood-mart", label: "Wood Mart" },
  { key: "tech-mart", label: "Tech Mart" },
];

export default function NewArrivals() {
  const [mart, setMart] = useState("");
  return (
    <div>
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 pt-10">
        <h1 className="text-4xl font-extrabold text-midnight">New Arrivals</h1>
        <p className="mt-1 text-muted-foreground">The latest additions to our catalogue.</p>
        <div className="mt-6 flex flex-wrap gap-2">
          {TABS.map((t) => (
            <button key={t.key || "all"} data-testid={`newarr-tab-${t.key || "all"}`} onClick={() => setMart(t.key)}
              className={`rounded-full px-5 py-2 text-sm font-semibold transition-colors ${mart === t.key ? "bg-midnight text-white" : "border border-border text-muted-foreground hover:text-midnight"}`}>
              {t.label}
            </button>
          ))}
        </div>
      </div>
      <ProductListing key={mart} mart={mart || undefined} extraParams={{ is_new: "true" }} title="" />
    </div>
  );
}
